import React from "react";
import { useTranslation } from "react-i18next";
import RedWarningIcon from "../../assets/icons/red-warning.svg";
import "./ConfirmDeleteAccountModal.less";

export type ConfirmDeleteAccountModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
};

const ConfirmDeleteAccountModal: React.FC<ConfirmDeleteAccountModalProps> = ({ onConfirm, onCancel, isLoading }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => !isLoading && onCancel?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  return (
    <div className="confirm-delete-account-overlay" onClick={handleOverlayClick}>
      <div className="confirm-delete-account-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>
        <div className="confirm-delete-account-container">
          <img src={RedWarningIcon} className="confirm-delete-account-icon" alt="Warning" />
          <div className="confirm-delete-account-title">{t("delete-account-confirm-title")}</div>
          <div className="confirm-delete-account-desc">{t("delete-account-confirm-desc")}</div>
          <button type="button" className="confirm-delete-button" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? t("deleting") : t("confirm")}
          </button>
          <button type="button" className="confirm-cancel-button" onClick={onCancel} disabled={isLoading}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteAccountModal;
